import * as React from "react";
import Auth, { AuthUser } from "../../services/Auth";
import { AuthConsumer, UserConsumer } from "./AuthProvider";

export interface AuthAndUser {
  auth: Auth;
  user: AuthUser;
}

export interface Props {
  children: (props: AuthAndUser) => React.ReactNode;
}

function AuthAndUserConsumer(props: Props) {
  return (
    <AuthConsumer>
      {(auth: Auth) => (
        <UserConsumer>
          {(user: AuthUser) => props.children({ auth, user })}
        </UserConsumer>
      )}
    </AuthConsumer>
  );
}
export default AuthAndUserConsumer;



// WEBPACK FOOTER //
// ./src/components/AuthProvider/AuthAndUserConsumer.tsx